import React, { useState, useEffect } from 'react'
import { Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import Pagination from '@mui/material/Pagination'
import SearchInput from '../../Common/ui/searchInput'

const IndicatorsList = () => {
    const [indicatorsData] = useState([
        {
            column1: 'Certification plan',
            column2: 'Double Sided Indicator',
            column3: 'Performance Indicator',
            column4: 'March 2024'
        },
        {
            column1: 'Customer Satisfaction Rating (NPS)',
            column2: 'Single Sided Indicator',
            column3: 'Performance Indicator',
            column4: 'January 2024'
        },
        {
            column1: 'AR outstanding collection',
            column2: 'Single Sided Indicator',
            column3: 'Financial Indicator   ',
            column4: 'February 2024'
        },
        {
            column1: 'Certification plan',
            column2: 'Double Sided Indicator',
            column3: 'Performance Indicator',
            column4: 'March 2024'
        },
        {
            column1: 'Customer Satisfaction Rating (NPS)',
            column2: 'Single Sided Indicator',
            column3: 'Performance Indicator',
            column4: 'January 2024'
        },
        {
            column1: 'AR outstanding collection',
            column2: 'Single Sided Indicator',
            column3: 'Financial Indicator   ',
            column4: 'February 2024'
        }
    ])
    const [ currentPage, setCurrentPage ] = useState(1)
    const [ totalPages, setTotalPages ] = useState(1)
    const [pageSize] = useState(5)

    const [ filteredData, setFilteredData ] = useState([])

    // Calculate the total number of pages based on the page size and data length
    useEffect(() => {
        const totalPagesCount = Math.ceil(indicatorsData.length / pageSize)
        setTotalPages(totalPagesCount)
    }, [ indicatorsData, pageSize ])

    // Update filtered data when the current page changes
    useEffect(() => {
        const startIndex = (currentPage - 1) * pageSize
        const endIndex = startIndex + pageSize
        const dataForPage = indicatorsData.slice(startIndex, endIndex)
        setFilteredData(dataForPage)
    }, [ indicatorsData, currentPage, pageSize ])

    const handlePaginationChange = (event, value) => {
        setCurrentPage(value)
    }
    return (
        <div>
            <p className="ml-5 mt-5 text-medium font-bold"> Indicator List </p>
            <Card className='p-2'>
                <CardContent>
                    <div className='py-2'>
                        <SearchInput
                            data={indicatorsData}
                            setData={setFilteredData}
                        />
                    </div>
                    <TableContainer>
                        <Table className="grc-custom-table">
                            <TableHead className='grc-custom-table-head'>
                                <TableRow>
                                    <TableCell>Indicator Name</TableCell>
                                    <TableCell>Indicators</TableCell>
                                    <TableCell>Indicator Type</TableCell>
                                    <TableCell>Period</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{row.column1}</TableCell>
                                        <TableCell>{row.column2}</TableCell>
                                        <TableCell>{row.column3}</TableCell>
                                        <TableCell>{row.column4}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div className='flex justify-end mt-4'>
                        <Pagination
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePaginationChange}
                            variant="outlined"
                            shape="rounded"
                            color="primary"
                            showFirstButton
                            showLastButton
                        />
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}

export default IndicatorsList
